// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__ZUL4c","disabled":"FileBtn_disabled__qpobB","warn":"FileBtn_warn__37mnf","fade":"FileBtn_fade__1-LJf"};